import { z } from 'zod';
import { nonEmptyString, optionalText, uuidSchema } from './common';

export const createPropertySchema = z.object({
  customerId: uuidSchema,
  name: optionalText,
  addressLine1: nonEmptyString,
  addressLine2: optionalText,
  city: z.string().default(''),
  state: z.string().default(''),
  postalCode: z.string().default(''),
  gateCode: optionalText,
  accessNotes: optionalText,
  petNotes: optionalText,
  hazardNotes: optionalText,
  generalNotes: optionalText,
  latitude: optionalText,
  longitude: optionalText,
});

export const updatePropertySchema = createPropertySchema
  .partial()
  .refine((data) => Object.keys(data).length > 0, { message: 'Nothing to update' });

export type CreatePropertyInput = z.infer<typeof createPropertySchema>;
export type UpdatePropertyInput = z.infer<typeof updatePropertySchema>;
